// extracted by mini-css-extract-plugin
module.exports = {"blogEl":"style_blogEl___u_a8","imgContainer":"style_imgContainer__mCVg1"};